module.exports = __webpack_public_path__ + "fonts/RecklessNeue-Light.4dadcac0.ttf";